/**
 * Route classification for the public marketing site vs the PWA app shell.
 *
 * We keep a single SPA on one origin and split by path:
 *   - Public marketing site: `/`, `/how-it-works`, `/features`, `/plus`,
 *     `/safety`, `/faq`, `/terms`, `/privacy`, `/support`
 *   - App / PWA: `/app` (+ `/arena`, `/wallet`, `/chat` aliases), plus the
 *     existing `/signup`, `/login`, `/create-profile`, `/ticket/:code`,
 *     `/join/:token`, `/groups`, and admin routes.
 *
 * Ticket links (`/ticket/:code`) are intentionally NOT treated as app-entry
 * routes here so their dedicated boot/SW handling stays untouched.
 */

export const PUBLIC_SITE_ROUTES = [
  '/',
  '/how-it-works',
  '/features',
  '/plus',
  '/safety',
  '/faq',
  '/terms',
  '/privacy',
  '/support',
];

/** Routes that should render the app shell ("entered" experience). */
export const APP_ENTRY_ROUTES = ['/app', '/arena', '/wallet', '/chat'];

/** Aliases that simply forward into the canonical `/app` entry. */
export const APP_ENTRY_ALIASES = ['/arena', '/wallet', '/chat'];

function normalize(pathname) {
  const p = String(pathname || '/');
  if (p.length > 1 && p.endsWith('/')) return p.slice(0, -1);
  return p;
}

export function isPublicSiteRoute(pathname) {
  return PUBLIC_SITE_ROUTES.includes(normalize(pathname));
}

export function isAppEntryRoute(pathname) {
  const p = normalize(pathname);
  return p === '/app' || APP_ENTRY_ALIASES.includes(p);
}

export function isAppEntryAlias(pathname) {
  return APP_ENTRY_ALIASES.includes(normalize(pathname));
}
